var React = require('react');

function MailIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"64","cy":"64","r":"59","fill":"#CECECE","key":0}),React.createElement("path",{"d":"M64 66.7635L97.9526 39H30.0427L64 66.7635Z","fill":"white","key":1}),React.createElement("path",{"d":"M30 46.3213V88H98V46.3261L64 74.123L30 46.3213Z","fill":"white","key":2})]);
}

MailIcon.defaultProps = {"width":"128","height":"128","viewBox":"0 0 128 128","fill":"none"};

module.exports = MailIcon;

MailIcon.default = MailIcon;
